import { ref } from 'vue'
export const consentOpen = ref(false)
let pending, settle
export function askAiConsent() {
  if (!pending) {
    pending = new Promise(resolve => { settle = resolve })
    consentOpen.value = true
  }
  return pending
}
export function finishAiConsent(granted) {
  consentOpen.value = false
  settle?.(granted)
  pending = null; settle = null
}
